<template>
  <BaseLayout>
    <v-container fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg6>
          <ProtocolForm
            v-model="protocol"
            @submit="save"
            :backLink="{ name: 'protocols' }"
            title="Protokoll bearbeiten"
            submitText="Speichern"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </BaseLayout>
</template>

<script>
import Session from '@/models/session';
import Protocol from '@/models/protocol';

export default {
  name: 'Edit-Protocol',
  async initialAsyncData({ id, type }) {
    if (type === 'session') {
      await Session.findOrFetch(id);
    } else {
      await Protocol.findOrFetch(id);
    }
  },
  data() {
    const isSession = this.$route.params.type === 'session';
    const { id } = this.$route.params;
    const protocol = isSession ? Session.find(id) : Protocol.find(id);
    return {
      protocol,
    };
  },
  methods: {
    async save() {
      await this.protocol.update();
      this.$showSnackbar({ text: 'Erfolgreich gespeichert.', color: 'success' });
      this.$router.push({ name: 'protocols' });
    },
  },
};
</script>
